// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font_size_password {
  font-size: 80%;
  color: #808080;
  font-weight: 400;
}
.font_size_error {
  font-size: 10px;
  color: #808080;
  font-weight: 400;
}

.paddings {
  padding-left: 35% !important;
  padding-right: 35% !important;
  padding-top: 10%;
}

.padding_in_create_password {
  padding-left: 32% !important;
  padding-right: 32% !important;
}
.font_size_heading {
  font-size: 12px;
  color: #000;
  font-weight: 500;
}
.img_profile_shape11 {
  height: 100px;
  width: 100px;
  object-fit: fill;
  border-radius: 50px;
}

.button_login {
  width: auto !important;
  font-size: 90% !important;
  border-radius: 1px !important;
  padding: 2px 10px !important;
  background-color: #007bb6 !important;
}

.button_login:hover {
  width: auto !important;
  font-size: 90% !important;
  border-radius: 1px !important;
  padding: 2px 10px !important;
  background-color: #007bb6 !important;
}

.login_height {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 5%;
}

.background_image_login {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.heading_login {
  font-size: 32px;
  padding-top: 12%;
  font-weight: 400;
  color: white;
}

.heading2_login {
  font-size: 50px;
  font-weight: 500;
  line-height: 115%;
  color: white;
  text-transform: uppercase;
}

.heading3_login {
  font-size: 28px;
  font-weight: 400;
  line-height: 115%;
  color: white;
}

.heading4_login {
  padding-top: 5%;
  color: black;
  font-weight: 1000 !important;
  font-size: 26px;
}

.heading5_login {
  font-weight: 400 !important;
  font-size: 20px;
  color: gray;
}

.label_login {
  font-size: 12px;
  color: gray;
  font-weight: 400 !important;
}

.join_login {
  font-size: 12px;
  color: gray;
  font-weight: 400 !important;
}

.join2_login {
  font-size: 12px;
  color: blue;
  font-weight: 400 !important;
}

.button_linkedin {
  font-size: 22px;
}

.mob_logo {
  display: none;
}

.link_decoration {
  text-decoration: none;
}

.text_color_line {
  color: black;
  font-size: 10px;
}

.button_style_login {
  background-color: #25224a !important;
  border-top-left-radius: 1px !important;
  font-size: 80%;
}

.button_style_login:hover {
  background-color: #25224a !important;
  border-top-left-radius: 1px !important;
  font-size: 80%;
}

.right_arrow_login {
  color: #74ac72;
}

.img_width_login {
  width: 100%;
}

.img_bulb_width {
  width: 3.5%;
}

.warning_text {
  color: red;
  font-size: 80%;
  padding-top: 2%;
}

.center_copyright {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.show_privacy_policy {
  display: flex;
}

@media (max-width: 980px) {
  .center_copyright {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .login_height {
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .paddings {
    padding-left: 25% !important;
    padding-right: 25% !important;
    padding-top: 15%;
  }

  .background_image_login {
    display: none;
  }

  .heading4_login {
    padding-top: 5%;
    color: blue;
    font-weight: 700 !important;
    font-size: 26px;
  }

  .mob_logo {
    padding-top: 30% !important;
    display: block;
  }

  .show_privacy_policy {
    display: flex;
  }

  .mobile_padding_bottom {
    padding-bottom: 15% !important;
  }

  .heading4_login {
    padding-top: 40%;
    color: black;
    font-weight: 1000 !important;
    font-size: 26px;
  }
}

@media (max-width: 480px) {
  .paddings {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 25%;
  }

  .padding_in_create_password {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 10%;
  }

  .show_privacy_policy {
    display: none;
  }

  .center_copyright {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}

.primary-number-update {
  .float-label {
    .form-control {
      width: 100% !important;
      &:focus {
        border: 1px solid #cacaca !important;
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/DeleteAccountVerification/DeleteAccountVerifications.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yDAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE;MACE,sBAAsB;MACtB;QACE,oCAAoC;MACtC;IACF;EACF;AACF","sourcesContent":[".font_size_password {\n  font-size: 80%;\n  color: #808080;\n  font-weight: 400;\n}\n.font_size_error {\n  font-size: 10px;\n  color: #808080;\n  font-weight: 400;\n}\n\n.paddings {\n  padding-left: 35% !important;\n  padding-right: 35% !important;\n  padding-top: 10%;\n}\n\n.padding_in_create_password {\n  padding-left: 32% !important;\n  padding-right: 32% !important;\n}\n.font_size_heading {\n  font-size: 12px;\n  color: #000;\n  font-weight: 500;\n}\n.img_profile_shape11 {\n  height: 100px;\n  width: 100px;\n  object-fit: fill;\n  border-radius: 50px;\n}\n\n.button_login {\n  width: auto !important;\n  font-size: 90% !important;\n  border-radius: 1px !important;\n  padding: 2px 10px !important;\n  background-color: #007bb6 !important;\n}\n\n.button_login:hover {\n  width: auto !important;\n  font-size: 90% !important;\n  border-radius: 1px !important;\n  padding: 2px 10px !important;\n  background-color: #007bb6 !important;\n}\n\n.login_height {\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-top: 5%;\n}\n\n.background_image_login {\n  background-image: url(\"./banner.png\");\n  height: 100vh;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.heading_login {\n  font-size: 32px;\n  padding-top: 12%;\n  font-weight: 400;\n  color: white;\n}\n\n.heading2_login {\n  font-size: 50px;\n  font-weight: 500;\n  line-height: 115%;\n  color: white;\n  text-transform: uppercase;\n}\n\n.heading3_login {\n  font-size: 28px;\n  font-weight: 400;\n  line-height: 115%;\n  color: white;\n}\n\n.heading4_login {\n  padding-top: 5%;\n  color: black;\n  font-weight: 1000 !important;\n  font-size: 26px;\n}\n\n.heading5_login {\n  font-weight: 400 !important;\n  font-size: 20px;\n  color: gray;\n}\n\n.label_login {\n  font-size: 12px;\n  color: gray;\n  font-weight: 400 !important;\n}\n\n.join_login {\n  font-size: 12px;\n  color: gray;\n  font-weight: 400 !important;\n}\n\n.join2_login {\n  font-size: 12px;\n  color: blue;\n  font-weight: 400 !important;\n}\n\n.button_linkedin {\n  font-size: 22px;\n}\n\n.mob_logo {\n  display: none;\n}\n\n.link_decoration {\n  text-decoration: none;\n}\n\n.text_color_line {\n  color: black;\n  font-size: 10px;\n}\n\n.button_style_login {\n  background-color: #25224a !important;\n  border-top-left-radius: 1px !important;\n  font-size: 80%;\n}\n\n.button_style_login:hover {\n  background-color: #25224a !important;\n  border-top-left-radius: 1px !important;\n  font-size: 80%;\n}\n\n.right_arrow_login {\n  color: #74ac72;\n}\n\n.img_width_login {\n  width: 100%;\n}\n\n.img_bulb_width {\n  width: 3.5%;\n}\n\n.warning_text {\n  color: red;\n  font-size: 80%;\n  padding-top: 2%;\n}\n\n.center_copyright {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.show_privacy_policy {\n  display: flex;\n}\n\n@media (max-width: 980px) {\n  .center_copyright {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n  .login_height {\n    height: auto;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n\n  .paddings {\n    padding-left: 25% !important;\n    padding-right: 25% !important;\n    padding-top: 15%;\n  }\n\n  .background_image_login {\n    display: none;\n  }\n\n  .heading4_login {\n    padding-top: 5%;\n    color: blue;\n    font-weight: 700 !important;\n    font-size: 26px;\n  }\n\n  .mob_logo {\n    padding-top: 30% !important;\n    display: block;\n  }\n\n  .show_privacy_policy {\n    display: flex;\n  }\n\n  .mobile_padding_bottom {\n    padding-bottom: 15% !important;\n  }\n\n  .heading4_login {\n    padding-top: 40%;\n    color: black;\n    font-weight: 1000 !important;\n    font-size: 26px;\n  }\n}\n\n@media (max-width: 480px) {\n  .paddings {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    padding-top: 25%;\n  }\n\n  .padding_in_create_password {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    padding-top: 10%;\n  }\n\n  .show_privacy_policy {\n    display: none;\n  }\n\n  .center_copyright {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  }\n}\n\n.primary-number-update {\n  .float-label {\n    .form-control {\n      width: 100% !important;\n      &:focus {\n        border: 1px solid #cacaca !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
